<script setup>
import { onMounted, ref, nextTick } from 'vue';

defineProps(['modelValue']);

const emit = defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

const emitValue = (value) => {

  // Remove non-ASCII characters except diacritics
  let sanitizedValue = (!/^[ -~\u0300-\u036f]+$/.test(value)) ? value.replaceAll(/[^\u0020-\u007E\u00A0-\u024F]+/g, '') : value;

    if (value !== sanitizedValue){
      emit('update:modelValue', '-');
    }

    nextTick(() => {
      emit('update:modelValue', sanitizedValue);
    });

};

</script>

<template>
  <input class="form-control text-input" :value="modelValue" @input="emitValue($event.target.value)" ref="input">
</template>
